import { throttle } from 'lodash';
import { useEffect, useState } from 'react';

export enum WindowSize {
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
}

const getDeviceConfig = (width: number) => {
  if (width < 320) {
    return WindowSize.XS;
  } else if (width >= 320 && width < 768) {
    return WindowSize.SM;
  } else if (width >= 768 && width < 1024) {
    return WindowSize.MD;
  } else if (width >= 1024) {
    return WindowSize.LG;
  }
};

const useBreakpoint = () => {
  const [brkPnt, setBrkPnt] = useState(() =>
    getDeviceConfig(window.innerWidth)
  );

  useEffect(() => {
    const calcInnerWidth = throttle(function () {
      setBrkPnt(getDeviceConfig(window.innerWidth));
    }, 200);
    window.addEventListener('resize', calcInnerWidth);
    return () => window.removeEventListener('resize', calcInnerWidth);
  }, []);

  return brkPnt;
};
export default useBreakpoint;
